import React from 'react';
import styled from '@emotion/styled';


/* styles taken from site-footer, and footer__legal-link */
const Link = styled.a`
    color: #4632d8;
    transition: color .2s;
    text-decoration: underline;
    cursor: pointer;
    font-family: var(--bs-body-font-family);
    font-weight: var(--bs-body-font-weight);
    line-height: var(--bs-body-line-height);
`;

const tAndCUrl = 'https://www.simplybusiness.com/terms-conditions/';
const privacyPolicyUrl = 'https://www.simplybusiness.com/privacy-policy/';
const privacyNoticeCaUrl = 'https://www.simplybusiness.com/privacy-policy/#special-notice-california-residents';
const responsibleDisclosureUrl = 'https://www.simplybusiness.com/responsible-disclosure/';
const doNotSellShareUrl = 'https://www.simplybusiness.com/personal-information/';

const USContactInfoContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 16px;
    row-gap: 32px;
    padding-top: 1.5rem;
    padding-bottom: 0.75rem;
    -webkit-font-smoothing: antialiased;

    @media (max-width: 959px) {
        grid-template-columns: 1fr;
        column-gap: 0;
    }
`;

const UsContactInfoAddress = styled.div`
    grid-column: 2;
    display: flex;
    flex-direction: column;

    @media (max-width: 959px) {
        grid-column: 1;
    }
`;

const UsContactInfoLinks = styled.div`
    grid-column: 3;
    display: flex;
    flex-direction: column;
    max-width: 250px;

    @media (max-width: 959px) {
        grid-column: 1;
    }
`;


const BodyText = styled.p`
    font-family: var(--bs-body-font-family);
    font-weight: var(--bs-body-font-weight);
    font-size: var(--font-size-small-paragraph);
    line-height: 1.2857142857;
    color: var(--color-text-medium);
    margin: 0;
`;

const HeadingText = styled.h2`
    line-height: 1.3;
    font-size: var(--font-size-small-paragraph);
    font-weight: bold;
    color: black;
    margin: 0 0 0.5rem 0;
`;

const LegalLinkList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;

const LegalLinkListItem = BodyText.withComponent('li');


const USContactInfo = (): React.JSX.Element => (
  <USContactInfoContainer data-testid={'us-contact-info'}>
    <UsContactInfoAddress>
      <HeadingText>Address</HeadingText>
      <BodyText>Simply Business</BodyText>
      <BodyText>53 State Street, 19th Floor</BodyText>
      <BodyText>Boston, MA</BodyText>
      <BodyText>02109</BodyText>
    </UsContactInfoAddress>
    <UsContactInfoLinks>
      <HeadingText>Legal</HeadingText>
      <LegalLinkList role={'list'}>
        <LegalLinkListItem>
          <Link href={tAndCUrl} target={'_blank'}>Terms of Service</Link>
        </LegalLinkListItem>
        <LegalLinkListItem>
          <Link href={privacyPolicyUrl} target={'_blank'}>Privacy Policy</Link>
        </LegalLinkListItem>
        <LegalLinkListItem>
          <Link href={privacyNoticeCaUrl} target={'_blank'}>Privacy Notice for CA Residents</Link>
        </LegalLinkListItem>
        <LegalLinkListItem>
          <Link href={responsibleDisclosureUrl} target={'_blank'}>Responsible Disclosure Policy</Link>
        </LegalLinkListItem>
        <LegalLinkListItem>
          <Link href={doNotSellShareUrl} target={'_blank'}>
            Do Not Sell or Share my Personal Information (CA Residents)
          </Link>
        </LegalLinkListItem>
      </LegalLinkList>
    </UsContactInfoLinks>
  </USContactInfoContainer>
);

export default USContactInfo;
